import { Dialog } from 'primereact/dialog';
import React, { FC } from 'react';

import ActualPrStats from '../ActualPrStats/ActualPrStats';
import { PlayerParamsProps } from './PlayerInfo.types';

const PlayerInfo: FC<PlayerParamsProps> = ({ isVisible, player, onHide }) => (
  <Dialog
    visible={isVisible}
    onHide={onHide}
    header="Player info"
    headerClassName="text-center"
    className="PlayerInfo-Component"
    pt={{
      root: { onClick: (e: React.MouseEvent) => e.stopPropagation() },
      mask: { onClick: (e: React.MouseEvent) => e.stopPropagation() },
      closeButton: { onClick: (e: React.MouseEvent) => e.stopPropagation() },
    }}
  >
    <ActualPrStats actualPrStats={player.actualPrStats} />
  </Dialog>
);

export default PlayerInfo;
